import { PVFileExt } from '@/classes/scenario/pv/PVFileExt';
import { PVCurveExt } from '@/classes/scenario/pv/PVCurveExt';
import { ScenarioPV } from '@/dto/scenario/pv/ScenarioPV';
import { DtoExt } from '@/classes/scenario/DtoExt';
import { SurfaceDefinitionExt } from '@/classes/scenario/pv/SurfaceDefinitionExt';

export class ScenarioPVExt extends DtoExt {
  public readonly isRenExplorer: boolean;

  public static fromDto(dto: ScenarioPV): ScenarioPVExt {
    return new ScenarioPVExt({
      hasUploadedPV: dto.hasUploadedPV,
      hasSurfaceDefinition: dto.hasSurfaceDefinition,
      file: dto.file && PVFileExt.fromDto(dto.file),
      surfaceDefinition: dto.surfaceDefinition && SurfaceDefinitionExt.fromDto(dto.surfaceDefinition),
      calculatedCurve: dto.calculatedCurve && PVCurveExt.fromDto(dto.calculatedCurve),
      panelDegradation: dto.panelDegradation,
      moduleRef: dto.moduleRef,
      invertersLifetime: dto.invertersLifetime,
      maintenanceEfficiency: dto.maintenanceEfficiency,
      panelCapacity: dto.panelCapacity,
      panelArea: dto.panelArea,
      forcedAnnualYieldResults: dto.annualYieldResults
    });
  }

  public hasUploadedPV: boolean | null;
  public hasSurfaceDefinition: boolean | null;
  public completeAvailableArea: number | null;

  public calculatedCurve: PVCurveExt | null; // NOT CURRENTLY FED

  public file: PVFileExt | null; // Partially fed
  public surfaceDefinition: SurfaceDefinitionExt | null;

  public moduleRef: string | null;

  public invertersLifetime: number | null;
  public maintenanceEfficiency: number | null;
  public panelCapacity: number | null;
  public panelArea: number | null;
  public panelDegradation: number | null;

  public pvCapacity: number | null;
  public forcedAnnualYieldResults: number | null;

  constructor(options?: Partial<ScenarioPVExt> | null) {
    super();
    this.isRenExplorer = options?.isRenExplorer ?? false;
    this.hasUploadedPV = options?.hasUploadedPV === undefined ? true : options.hasUploadedPV;
    this.hasSurfaceDefinition = options?.hasSurfaceDefinition ?? null;
    this.completeAvailableArea = options?.completeAvailableArea ?? null;
    this.calculatedCurve = options?.calculatedCurve ?? null;
    this.file = options?.file ?? null;
    this.surfaceDefinition = options?.surfaceDefinition ?? null;
    this.moduleRef = options?.moduleRef ?? null;
    this.invertersLifetime = options?.invertersLifetime ?? 15;
    this.maintenanceEfficiency = options?.maintenanceEfficiency ?? 0.98;
    this.panelCapacity = options?.panelCapacity ?? null;
    this.panelArea = options?.panelArea ?? null;
    this.panelDegradation = options?.panelDegradation ?? null;
    this.pvCapacity = options?.pvCapacity ?? null;
    this.forcedAnnualYieldResults = options?.forcedAnnualYieldResults ?? null;
  }

  get energy(): number | null {
    if (this.hasSurfaceDefinition && this.isRenExplorer) {
      return this.surfaceDefinition?.annualEnergy ?? null;
    }
    if (this.pvCapacity === null || this.annualYieldResults === null) {
      return null;
    }
    return this.pvCapacity * this.annualYieldResults;
  }

  get annualYieldResults() {
    if (this.hasSurfaceDefinition && this.isRenExplorer) {
      return this.surfaceDefinition?.annualYieldResults ?? null;
    } else {
      return this.forcedAnnualYieldResults;
    }
  }

  set annualYieldResults(annualYieldResults: number | null) {
    this.forcedAnnualYieldResults = annualYieldResults;
  }

  public toDto(): ScenarioPV {
    return new ScenarioPV({
      hasUploadedPV: this.hasUploadedPV,
      hasSurfaceDefinition: this.hasSurfaceDefinition,
      file: this.file && this.file.toDto(),
      surfaceDefinition: this.surfaceDefinition && this.surfaceDefinition.toDto(),
      calculatedCurve: this.calculatedCurve && this.calculatedCurve.toDto(),
      panelDegradation: this.panelDegradation,
      moduleRef: this.moduleRef,
      invertersLifetime: this.invertersLifetime,
      maintenanceEfficiency: this.maintenanceEfficiency,
      panelCapacity: this.panelCapacity,
      panelArea: this.panelArea,
      annualYieldResults: this.annualYieldResults
    });
  }
}
